import { trackSimpleVisit, trackUserLogin } from '@/API/track/track';

/**
 * 获取当前登录用户的 userId
 * 优先取普通用户，其次取监管用户
 * @returns {string|null} userId 或 null
 */
function getCurrentUserId() {
  try {
    const ordinaryUser = localStorage.getItem('ordinaryUser');
    if (ordinaryUser) {
      const parsed = JSON.parse(ordinaryUser);
      if (parsed && parsed.userDetail && parsed.userDetail.userId) {
        return parsed.userDetail.userId;
      }
    }

    const supervisionUser = localStorage.getItem('supervisionUser');
    if (supervisionUser) {
      const parsed = JSON.parse(supervisionUser);
      if (parsed && parsed.userDetail && parsed.userDetail.userId) {
        return parsed.userDetail.userId;
      }
    }
  } catch (e) {
    console.error('获取用户ID失败:', e);
  }
  return null;
}

/**
 * 页面访问埋点
 * 已登录则传 userId，未登录则不传
 */
export function trackPageVisit() {
  const userId = getCurrentUserId();
  const data = userId ? { userId } : {};
  trackSimpleVisit(data).catch((err) => {
    console.error('页面访问埋点上报失败:', err);
  });
}

/**
 * 用户登录埋点
 * @param {string} userId 用户ID
 */
export function trackLogin(userId) {
  if (!userId) {
    console.warn('登录埋点缺少 userId，跳过上报');
    return;
  }
  trackUserLogin({ userId }).catch((err) => {
    console.error('登录埋点上报失败:', err);
  });
}
